import { CRM_SYSTEMS_IDS } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.constants.gen";
import { CrmSystemIds } from "@/features/crm_system/lib/_core/crmSystem/crmSystem.types.gen";
import { z } from "zod";

export const organizationFormSchema = z.object({
    name: z.string({ message: "Organization name is required" }).min(2, { message: "Organization name must be at least 2 characters long" }),
    crm_connections: z.array(z.enum(CRM_SYSTEMS_IDS as unknown as [CrmSystemIds, ...CrmSystemIds[]])).min(1, { message: "At least one CRM connection is required" }),
    organization_type: z.enum(['organization','user'], {error: "Organization type is required"}),
})

